/**
 * Componente raíz. Captura el deep link de Google OAuth en Capacitor.
 */
import React, { useEffect, useState } from "react";
import MainRoutes from "./MainRoutes";
import Toast from "./Toast";
import GlobalChatNotifications from "./components/GlobalChatNotifications";
import CompiBot from "./components/CompiBot";
import sqliteService from "./services/sqliteService";
import syncService from "./services/syncService";
import { registrarFCMToken, iniciarListenerNotificaciones } from "./services/notificacionesService";
import api from "./api/axios";
import { Capacitor } from "@capacitor/core";

function App() {
    const [toastMsg, setToastMsg] = useState("");
    const [hasToken, setHasToken] = useState(!!localStorage.getItem("token"));
    const esNativo = Capacitor.isNativePlatform();

    useEffect(() => {
        window.showToast = setToastMsg;
        const initNativeFeatures = async () => {
            await sqliteService.init();
            syncService.init();

            if (hasToken) {
                await registrarFCMToken(api);
                await iniciarListenerNotificaciones();
            }
        };
        initNativeFeatures().catch(err => console.error(err));
    }, []);

    useEffect(() => {
        /**
         * Listener de deep link para OAuth Google en Capacitor.
         * El backend redirige a capacitor://localhost/?token=xxx tras el login.
         * Aquí capturamos ese token y navegamos a /compare.
         */
        let cleanupAppUrl = () => {};

        if (esNativo) {
            const registerListener = async () => {
                try {
                    const { App: CapApp } = await import("@capacitor/app");
                    const { Browser }     = await import("@capacitor/browser");

                    const listener = await CapApp.addListener("appUrlOpen", async (event) => {
                        const url = event.url;
                        if (!url) return;

                        try {
                            const urlObj = new URL(url);
                            const token  = urlObj.searchParams.get("token");
                            const nombre = urlObj.searchParams.get("nombre");
                            const foto   = urlObj.searchParams.get("foto");
                            const email  = urlObj.searchParams.get("email");
                            const error  = urlObj.searchParams.get("error");

                            if (error) {
                                console.error("Error OAuth Google:", error);
                                await Browser.close();
                                return;
                            }

                            if (token) {
                                localStorage.setItem("token",       token);
                                localStorage.setItem("user_nombre", nombre || "");
                                localStorage.setItem("user_foto",   foto   || "");
                                localStorage.setItem("user_email",  (email || "").toLowerCase());
                                window.dispatchEvent(new Event("storage"));
                                await Browser.close();
                                // Forzar navegación a /compare
                                window.location.href = "/compare";
                            }
                        } catch (err) {
                            console.error("Error procesando appUrlOpen:", err);
                        }
                    });

                    cleanupAppUrl = () => listener.remove();
                } catch (err) {
                    console.error("Error registrando listener appUrlOpen:", err);
                }
            };
            registerListener();
        }

        return () => cleanupAppUrl();
    }, [esNativo]);

    useEffect(() => {
        const checkToken = (e) => {
            if (e && e.key && e.key !== "token") return;
            const token = !!localStorage.getItem("token");
            setHasToken((prev) => prev === token ? prev : token);
        };
        window.addEventListener("storage", checkToken);
        const i = setInterval(checkToken, 2000);
        return () => {
            window.removeEventListener("storage", checkToken);
            clearInterval(i);
        };
    }, []);

    return (
        <>
            {hasToken && (
                <>
                    <GlobalChatNotifications />
                    {!esNativo && <CompiBot />}
                </>
            )}
            <MainRoutes />
            <Toast mensaje={toastMsg} onClose={() => setToastMsg("")} />
        </>
    );
}

export default App;